import React from "react";
// import OutsideClickHandler from "react-outside-click-handler";
import ReactTooltip from "react-tooltip";

import { Typography } from "@mui/material";
import { useFilePreviewHooks } from "components/old-data-box-components";
import { FileIcon } from "components/old-data-box-components";
import { ContextMenu, FileViewer } from "components/popups";
import { IFile } from "store/types";
import { bytesToMb } from "utils/files";

import "./EmailFilePreview.styles.scss";

export interface EmailFilePreviewProps {
  file: IFile;
  className?: string;
}

export const EmailFilePreview: React.FC<EmailFilePreviewProps> = ({ file }) => {
  const {
    // refToInput,
    // setIsInputActive,
    onDownload,
    isOpen,
    setIsOpen,
    actionHandler
  } = useFilePreviewHooks(file);

  const sizeInMb = bytesToMb(file.size_in_bytes);

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <div className="emails-file__preview no-outline">
      <div className="file-preview__content flex-row-fs-fs no-outline">
        <div className="file-preview__icon">
          <FileIcon type={file.type} />
        </div>
        <div className="file-preview__name-block flex-col-fs-st">
          <Typography
            fontSize="15px"
            fontWeight="500"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
            overflow="hidden"
            padding="2px 4px 4px 4px"
            sx={{
              "&:hover": {
                textDecoration: "underline"
              }
            }}
            onClick={actionHandler}
          >
            {file.name}
          </Typography>
          <div className="file-preview__size flex-row-fs-fc">
            <span>{sizeInMb}MB</span>
          </div>
        </div>
        <ReactTooltip delayShow={250} className="tooltip" place="top" effect="solid" type="light" />
      </div>
      <FileViewer file={file} isOpen={isOpen} onClose={onClose} />
      <ContextMenu
        options={{
          onDownload
        }}
      />
    </div>
  );
};
